/** Pause playtime counting after this much time without user interaction. */
export const PLAYTIME_IDLE_THRESHOLD_MS = 3 * 60 * 1000;

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'click', 'touchstart', 'scroll'] as const;

/**
 * Seconds of playtime to credit since the last sync, excluding idle time
 * beyond the threshold after the user's last interaction.
 */
export function getActivePlaytimeIncrementSeconds(
  lastSyncMs: number,
  lastActivityMs: number,
  nowMs: number,
  idleThresholdMs: number = PLAYTIME_IDLE_THRESHOLD_MS
): number {
  const activeUntil = lastActivityMs + idleThresholdMs;
  const effectiveEnd = Math.min(nowMs, activeUntil);
  return Math.floor(Math.max(0, effectiveEnd - lastSyncMs) / 1000);
}

/** DOM events that count as active play (reading, clicking, scrolling, typing). */
export function bindPlaytimeActivityListeners(onActivity: () => void): () => void {
  const handler = () => onActivity();
  ACTIVITY_EVENTS.forEach((event) => {
    window.addEventListener(event, handler, { passive: true });
  });
  return () => {
    ACTIVITY_EVENTS.forEach((event) => {
      window.removeEventListener(event, handler);
    });
  };
}
